import { Injectable } from '@angular/core';
import { IResourceMethodPromise, Resource, ResourceAction, ResourceHandler, ResourceParams, ResourceRequestMethod, ResourceResponseBodyType } from '@ngx-resource/core';
import { IMongooseResult } from './api.module';

@ResourceParams({
  pathPrefix: '/api/weborder',
})
@Injectable()
export class CartResource extends Resource {

  constructor(handler: ResourceHandler) {
    super(handler);
  }


  @ResourceAction({
    method: ResourceRequestMethod.Get,
    path: ''
  })
  query: IResourceMethodPromise<any, IMongooseResult<any>>;

  @ResourceAction({
    method: ResourceRequestMethod.Get,
    path: '/{!nmbr}'
  })
  getOne: IResourceMethodPromise<any, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Get,
    path: '/{!nmbr}/product'
  })
  getProducts: IResourceMethodPromise<any, IMongooseResult<any>>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: '/{!nmbr}/finish'
  })
  finish: IResourceMethodPromise<any, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: '/{!nmbr}/unfinish'
  })
  unfinish: IResourceMethodPromise<any, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: '/{!nmbr}/refreshCost'
  })
  refreshCost: IResourceMethodPromise<any, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Get,
    responseBodyType: ResourceResponseBodyType.Text,
    path: '/{!nmbr}/qr-code'
  })
  getQrCode: IResourceMethodPromise<any, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Get,
    path: '/{!nmbr}/cart-text'
  })
  getCartText: IResourceMethodPromise<any, { text: string }>;



  @ResourceAction({
    method: ResourceRequestMethod.Delete,
    path: '/{!webordernmbr}/product/{!productkey}/sequence/{!sequence}'
  })
  deleteProduct: IResourceMethodPromise<any, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: '/{!webordernmbr}/product/{!productkey}/sequence/{!sequence}'
  })
  updateProduct: IResourceMethodPromise<any, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: ''
  })
  create: IResourceMethodPromise<any, IMongooseResult<any>>;

  @ResourceAction({
    method: ResourceRequestMethod.Post,
    path: '/{!nmbr}/product/{!productkey}'
  })
  addProduct: IResourceMethodPromise<any, any>;


  getCart(doNotCreateOne?: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      this.query({ 'weborders.weborderstate': '<29' }).then((data) => {
        if (data.results.length > 0) {
          resolve(data.results[0]);
        } else if (doNotCreateOne) {
          resolve(undefined);
        } else {
          this.create().then((newCart) => {
            resolve(newCart);
          });
        }
      }, (err) => { });
    });
  }

}
